//Accordion
(function ($) {
    function accordion() {
        let accordionList = $('.accordion');

        accordionList.each(function () {
            let accordionItem = $('.accordion__item');
            let arrows = $('.accordion__item-content-arrow, .accordion__item-arrow');

            accordionItem.on('click', function () {
                let accordionItemHeight = $(this).children('.accordion__item-content').outerHeight();

                if (!$(this).hasClass('active')) {

                    $('.accordion__item').removeClass('active');
                    $(this).addClass('active');
                    $(this).attr('style', '--accordionItemHeight:' + accordionItemHeight + 'px')
                }
            });

            arrows.on('click', function (e){
                if($(this).parents('.accordion__item').hasClass('active')){
                    e.stopPropagation();
                    $(this).parents('.accordion__item').removeClass('active');
                }
            });
        });
    }

    accordion();
})(jQuery);